'use client';
import { jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import t from 'tiny-warning';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { CollapsibleContext } from './collapsible.context.js';
import { useAccordionContext } from '../accordion/accordion.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';

function _define_property(e, o, t) {
    return o in e ? Object.defineProperty(e, o, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[o] = t, e;
}
function _object_spread(e) {
    for(var o = 1; o < arguments.length; o++){
        var t = null != arguments[o] ? arguments[o] : {}, r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function(o) {
            _define_property(e, o, t[o]);
        });
    }
    return e;
}
function ownKeys(e, o) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t.push.apply(t, r);
    }
    return t;
}
function _object_spread_props(e, o) {
    return o = null != o ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys(Object(o)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    }), e;
}
function _object_without_properties(e, o) {
    if (null == e) return {};
    var t, r, n = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for(r = 0; r < l.length; r++)t = l[r], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var t, r, n = {}, l = Object.keys(e);
    for(r = 0; r < l.length; r++)t = l[r], o.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
let useCollapsibleContextProps = (e)=>{
    let { expanded: n, onRequestExpandedChange: l, defaultExpanded: i = false, collapsibleId: p, disabled: s = false, headingLevel: c } = e, [d, u] = useState(), b = useAccordionContext(), f = void 0 !== b;
    t(!f || void 0 === n && void 0 === l, 'When a Collapsible is used inside of an Accordion, you must provide the expanded-state to the Accordion component rather than directly to the Collapsible'), t(!(f && void 0 === p), 'When a Collapsible is used inside of an Accordion, the Collapsible must have a `collapsibleId`');
    let [m, y] = useControllableValue({
        value: n,
        onChange: l || void 0,
        defaultValue: i,
        defaultOnChange: (e, o)=>e(o)
    }), O = !!m, h = y;
    return f && (O = !!(null == b ? void 0 : b.expandedCollapsibleMap[p]), h = (e)=>{
        null == b || b.requestExpandedChange(p, e);
    }), {
        expanded: O,
        onRequestExpandedChange: h,
        contentId: d,
        setContentId: u,
        disabled: s,
        purpose: null == b ? void 0 : b.purpose,
        headingLevel: c
    };
}, c = 'Collapsible';
const Collapsible = renderWithRef(c, null, (o, t)=>{
    useComponentStylesLoaded(c, SWAN_STYLE_KEY_MAP.accordion);
    let { disabled: r = false, fullBleed: l = false, children: a, expanded: d, defaultExpanded: u, onRequestExpandedChange: b, collapsibleId: f, headingLevel: m } = o, y = _object_without_properties(o, [
        "disabled",
        "fullBleed",
        "children",
        "expanded",
        "defaultExpanded",
        "onRequestExpandedChange",
        "collapsibleId",
        "headingLevel"
    ]), O = new Set([
        'swan-vanilla-ignore',
        'swan-collapsible'
    ]);
    r && O.add('swan-collapsible-disabled'), l && O.add('swan-collapsible-full-bleed');
    let h = useCollapsibleContextProps({
        expanded: d,
        disabled: r,
        defaultExpanded: u,
        onRequestExpandedChange: b,
        collapsibleId: f,
        headingLevel: m
    }), j = _object_spread_props(_object_spread({}, y), {
        'aria-disabled': !!o.disabled,
        as: o.as || o.component || ((null == h ? void 0 : h.purpose) === 'list' ? 'li' : 'div')
    });
    return jsx(CollapsibleContext.Provider, {
        value: _object_spread({}, h),
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: t,
            classNames: O,
            props: j,
            children: a
        })
    });
});

export { Collapsible };
